export function IncrementList(liquor) {
    return {
        type: 'INCREMENT_LIST',
        liquor
    };
}
export function DecrementList(liquor) {
    return {
        type: 'DECREMENT_LIST',
        liquor
    };
}
export function GetList(slist) {
    return {
        type: 'GET_LIST',
        slist
    };
}
export function IncrementFavorite(store) {
    return {
        type: 'INCREMENT_FAVORITE',
        store
    };
}
export function DecrementFavorite(store) {
    return {
        type: 'DECREMENT_FAVORITE',
        store
    };
}
export function GetFavorite(flist) {
    return {
        type: 'GET_FAVORITE',
        flist
    };
}
export function SetAuth(login) {
    return {
        type: 'SET_AUTH',
        login
    };
}
export function ToggleLogin() {
    return {
        type: 'TOGGLE_LOGIN'
    };
}
export function ToggleLoginHeader() {
    return {
        type: 'TOGGLE_LOGIN_HEADER'
    };
}
export function ToggleLoading() {
    return {
        type: 'TOGGLE_LOADING'
    };
}
//# sourceMappingURL=index.js.map